<template>
  <subsidiary-table
    :api-u-r-l="apiURL"
    :title="title"
    module="subsidiary"
  />
</template>

<script>
import SubsidiaryTable from '~/components/SubsidiaryTable';

export default {
  middleware: 'auth',
  components: {
    SubsidiaryTable,
  },
  props: {
    id: { default: '' },
  },
  data: () => ({
    name: '',
  }),
  computed: {
    apiURL() {
      return `/api/enterprises/${this.id}/subsidiarie`;
    },
    title() {
      return 'Sucursales';
    },
  },
};
</script>
